<template>
   <card-seplag titulo="Relatório Consolidado Por Órgão">

    <div class="p-col-12" style="display: flex;flex-direction: row;justify-content: space-between;">
      <div style="display: flex;">
        <Button 
          @click="exportExcel"
          label="Excel" 
          icon="pi pi-external-link" 
          class="p-button-raised" 
          style="margin:5px;background:#107c41; border-color: rgb(1 114 52);" 
        />
        <Button 
          @click="exportPDF"
          label="PDF" 
          icon="pi pi-external-link" 
          class="p-button-raised" 
          style="margin:5px;background:#c5031d; border-color: #b70019;" 
        />
      </div>
        <div style="display: flex;align-items: center;">        
          <label style="margin:5px;font-weight: 600;color: rgb(110, 106, 106);">Exercício:</label>
          <Dropdown
            class="classe-dropdown"
            v-model="filtroTabela"
            :options="dropdownExercicio"
            optionLabel="numrAnoCalendario"
            style="width: 15rem;"
          />
        <Button label="Buscar" icon="pi pi-search" style="width: 6rem;" @click="filtrarExercicio"/>
      </div>
    </div>
    <table-seplag 
      :paginacao="false"
      :dados.sync="tabelaBens"
      :campos="camposTabelaBens"
      :hasExibirCabecalho="true"
     />

    <CardExibirPDF
      :tamanhoTela="'85,vw'"
      :alturaTela="'120,vh'"
      :pdfElement="dadosRelatorioBase64"
      v-model="isExibirPDF"
      :tituloTela="tituloPDF"
      v-if="isExibirPDF"
    />
   </card-seplag>
</template>

<script>

import CardSeplag from '@/template/CardSeplag.vue'
import TableSeplag from '../../template/TableSeplag.vue'
import {baseApiUrl} from '@/config/global'
import download from 'downloadjs';
import CardExibirPDF from "@/template/CardExibirPDF";

export default {
  name: "RelatorioConsolidado",
  components: { CardSeplag,TableSeplag, CardExibirPDF },    
  data() {
    return {
      tabelaBens:[],
      camposTabelaBens:[
        { nome: "descOrgao", titulo: "Órgão-Empresa"},
        { nome: "qtdeNaoRealizada", titulo: "Não Realizada",tamanho: "10.rem" },
        { nome: "qtdeFinalizada", titulo: "Finalizada Entregue",tamanho: "14.rem" },
        { nome: "qtdeFinalizadaAlterada", titulo: "Finalizada - Alterada Entregue",tamanho: "13.rem" },
        { nome: "totalEntregue", titulo: "Total Entregue",tamanho: "13.rem" },
        { nome: "total", titulo: "Total de Funcionários",tamanho: "18.rem" },
      ],
      exercicioVigente:0,
      isExibirPDF: false,
      tituloPDF: " ",
      dadosRelatorioBase64: "",
      filtroTabela: null,
      dropdownExercicio:null
    }
  },methods:{
    async carregarDados(){

      let resultado = await this.$http.get(`${baseApiUrl}/parametroexercicios/vigente`)
      if(resultado.data!=''){
        await this.$http.get(`${baseApiUrl}/relatorioconsolidado/gerar/${resultado.data.idenExercicio}`).then(res =>{
            this.tabelaBens = res.data
            let total = {
              descOrgao:"Total Geral",
              qtdeNaoRealizada: this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.qtdeNaoRealizada,0),
              qtdeFinalizada: this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.qtdeFinalizada,0),
              qtdeFinalizadaAlterada:this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.qtdeFinalizadaAlterada,0),
              totalEntregue:this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.totalEntregue,0),
              total:this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.total,0),
            }

            this.tabelaBens.push(total)
        })
      }
      this.$http.get(`${baseApiUrl}/parametroexercicios/all`).then(res2 =>{
            this.dropdownExercicio = res2.data           
            if(this.tabelaBens.length > 0){
              this.filtroTabela = res2.data.filter(function(element){
                return element.exercicio.idenExercicio == resultado.data.idenExercicio
              })[0]
            }
          })

    },
    exportExcel(){
      
      let jsonPost = {
          idenExercicio: this.filtroTabela.exercicio.idenExercicio,
          orgaoLotacao:this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor[0].descOrgao,
          usuarioLogado:this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
          tipoRelatorio:"E"
      }

      this.$http.post(`${baseApiUrl}/relatorios/relatorioconsolidado`,JSON.stringify(jsonPost))
                .then(res =>{
                  download(`data:application/excel;base64,${res.data.dadosRelatorioBase64}`, `${res.data.nomeArquivo}`, "application/excel");          
                })
      
    },
    exportPDF(){
      let jsonPost = {
          idenExercicio: this.filtroTabela.exercicio.idenExercicio,
          orgaoLotacao:this.$store.getters.getUser.contaAcesso.pessoa.listaServidorOrgaoSetor[0].descOrgao,
          usuarioLogado:this.$store.getters.getUser.contaAcesso.pessoa.nomePessoa,
          tipoRelatorio:"P"
      }

      this.$http
        .post(
          `${baseApiUrl}/relatorios/relatorioconsolidado`,
          JSON.stringify(jsonPost)
        )
        .then((res) => {
          this.dadosRelatorioBase64 = `data:application/pdf;base64,${res.data.dadosRelatorioBase64}`;
          this.isExibirPDF = true;
          
        });
    },
    async filtrarExercicio(){
      if(this.filtroTabela != null){
       await this.$http.get(`${baseApiUrl}/relatorioconsolidado/gerar/${this.filtroTabela.exercicio.idenExercicio}`).then(res =>{
          this.tabelaBens = res.data
          let total = {
            descOrgao:"Total Geral",
            qtdeNaoRealizada: this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.qtdeNaoRealizada,0),
            qtdeFinalizada: this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.qtdeFinalizada,0),
            qtdeFinalizadaAlterada:this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.qtdeFinalizadaAlterada,0),
            totalEntregue:this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.totalEntregue,0),
            total:this.tabelaBens.reduce((acc,valorAtual)=>acc + valorAtual.total,0),
          }

          this.tabelaBens.push(total)
        })
      }
    }
    
  },
  mounted(){
    this.carregarDados()
  }
}
</script>

<style scoped>
    
</style>